/*
 * PWA service-worker registration
 * -------------------------------
 * We register the SW whenever the app is served from a non-localhost origin
 * — that includes the preview URL and the production deploy. Local dev
 * (localhost / 127.0.0.1 hot-reload) is skipped because CRA's HMR fights
 * with cached bundles and makes edits confusing to test. Also detects a
 * waiting worker on ``updatefound`` and, when the user next navigates,
 * tells it to ``SKIP_WAITING`` so the freshest shell is delivered without
 * a hard reload.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Skip only on real localhost hot-reload sessions. The preview URL is
  // hosted on a public HTTPS domain, so the SW is exercisable there — this
  // lets us validate offline + installability against staging before ship.
  const host = window.location.hostname;
  const isLocalhost = host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0";
  if (isLocalhost) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // When a new worker takes over, ping it to activate immediately.
        reg.addEventListener("updatefound", () => {
          const next = reg.installing;
          if (!next) return;
          next.addEventListener("statechange", () => {
            if (next.state === "installed" && navigator.serviceWorker.controller) {
              // A newer SW is ready — activate on next navigation.
              try { next.postMessage({ type: "SKIP_WAITING" }); } catch (_e) { /* noop */ }
            }
          });
        });
      })
      .catch((err) => {
        // Don't break the app if the SW can't register (browser blocks it,
        // network hiccup during first paint). Just log for diagnostics.
        // eslint-disable-next-line no-console
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
}
